import React from "react";
import FaqWrapper from "./FaqWrapper";

function FaqPage() {
  return (
    <>
      <FaqWrapper />
    </>
  );
}

export default FaqPage;
